import { UI, HStack, Stack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { ColorCodedText } from '../../../../../components/ColorCodedText';
import { OperationType } from '../../../../../components/OperationType';
import { TableContent, TableContentItemColumn } from '../../../../../components/TableContent';
import { FixedIncomeAssetsQueryItem } from '../../../../../store/customerAssetDetail/types';
import { AccordionButton } from '../../AccordionButton';
import { QuoteButton } from '../../QuoteButton';
import { IDynamicProductSearchItem } from '../_dynamic';

import { FixedIncomeDetails } from './components/FixedIncomeDetails';
import { tableHead } from './constants';

const ProductSearchItem = ({
  product,
  item,
  quoteButtonInfoGetter,
}: IDynamicProductSearchItem<FixedIncomeAssetsQueryItem>) => {
  const hasQuoteButton = !!quoteButtonInfoGetter;
  const [isOpen, setIsOpen] = React.useState(false);

  const renderSecondaryInfo = () => {
    return <FixedIncomeDetails product={item} />;
  };

  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent
      direction="column"
      space={0}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}>
      <Box
        position={'absolute'}
        top={0}
        left={0}
        bottom={0}
        w={'4px'}
        backgroundColor={Color[product.colorNormalized]}
        borderTopLeftRadius={'full'}
        borderBottomLeftRadius={'full'}
      />
      <HStack w="full" alignItems="center">
        <TableContentItemColumn flex={getFlex(0)}>
          <UI.Text>{item.productTypeNormalized}</UI.Text>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(1)}>
          <UI.Text>{item.productNameNormalized}</UI.Text>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(2)}>
          <UI.Text>{item.taxNormalized}</UI.Text>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(3)}>
          <Stack alignSelf="flex-start">
            <OperationType title={item.pricingMethod} />
          </Stack>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(4)}>
          <UI.Text>{item.availableQuantityNormalized.toString()}</UI.Text>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(5)}>
          <UI.Text>{item.blockedQuantityNormalized.toString()}</UI.Text>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(6)}>
          <UI.Text>{item.quantityNormalized.toString()}</UI.Text>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(7)}>
          <UI.Text>{item.maturityDateNormalized}</UI.Text>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(8)}>
          <UI.Text>{item.valueNormalized}</UI.Text>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(9)}>
          <ColorCodedText text={item.variationNormalized} sign={item.variationType} />
        </TableContentItemColumn>
        {hasQuoteButton && (
          <TableContentItemColumn flex={getFlex(10)}>
            <HStack>
              <QuoteButton {...quoteButtonInfoGetter(item)} />
              <AccordionButton isOpen={isOpen} setIsOpen={setIsOpen} />
            </HStack>
          </TableContentItemColumn>
        )}
      </HStack>
      {!!isOpen && renderSecondaryInfo()}
    </TableContent>
  );
};

export default React.memo(ProductSearchItem);
